import request from '@/service/request'

/* 赠送电费 批次 page */
export const pageFreeElectricBatchApi = (params) => {
  return request.post('/stu/autoFreeCharging/batch/page', params)
}

/* 赠送电费 新电表 赠送电记录 page 仅用于 批量赠电模块，其他模块用下一个接口 */
export const pageNewFreeElectricBatchApi = (params) => {
  return request.post('/handle/dormitoryRoomElectricityRecharge/pageSetBatchList', params)
}

/* 赠送电费 新电表 充值/赠送/清零记录 page */
export const pageNewFreeElectricFreeRecordApi = (params) => {
  return request.post('/handle/dormitoryRoomElectricityRecharge/page', params)
}

/* 赠送电费 批次 list
* batchId {string} 批次id
* status {number} 状态，-1可用于获取未赠送的数据
*  */
export const listFreeElectricBatchApi = (params) => {
  return request.post('/stu/autoFreeCharging/list', params)
}

/* 赠送电费 批次 删除
* id { string } 批次id
* */
export const delFreeElectricBatchApi = (id) => {
  return request.post(`/stu/autoFreeCharging/batch/delete/${id}`)
}

/* 赠送电费 批次 保存 */
export const saveFreeElectricBatchApi = (params) => {
  return request.post('/stu/autoFreeCharging/batch/save', params)
}

/* 赠送电费 批量绑定宿舍
* batchId { string } 批次id
* roomIds {array} 宿舍数组
* */
export const bindFreeElectricBatchApi = (params) => {
  return request.post('/stu/autoFreeCharging/batch/bind', params)
}

/* 赠送电费 批量绑定宿舍 新电表
* @params {string} batchId 批次id
* @params {Array} roomIds 宿舍数组
*  */
export const bindNewFreeElectricBatchApi = (params) => {
  return request.post('/handle/dormitoryRoomElectricityRecharge/bindChargingRoom', params)
}

/* 赠送电费 发送批量赠送请求 掌控电表
* id { string } 批次id
*/
export const sendFreeElectricByBatchIdApi = (id) => {
  return request.post(`/stu/autoFreeCharging/batch/send/${id}`)
}

/* 赠送电费 发送批量赠送请求 新电表
* @params { string } id 批次id
*/
export const sendNewFreeElectricByBatchIdApi = (id) => {
  return request.post(`/handle/dormitoryRoomElectricityRecharge/confirmChargingFeeBatch/${id}`)
}

/* 赠送电费 赠送记录 page */
export const pageFreeElectricRecordApi = (params) => {
  return request.post('/stu/autoFreeCharging/page', params)
}

/* 电费充值 接口
* @params {string} dormitoryRoomId 充值宿舍
* @params {string} userId 充值人id
* @params {number} rechargeNumber 充值金额
*  */
export const getRechargeQRCodeApi = (params) => {
  return request.post('/handle/dormitoryRoomElectricityRecharge/getChargingPayUrlForStuDto', params)
}

/* 电费充值 接口 微信充值
* @params {string} dormitoryRoomId 充值宿舍
* @params {string} userId 充值人id
* @params {number} rechargeNumber 充值金额
*  */
export const getWXRechargeQRCodeApi = (params) => {
  return request.post('/handle/dormitoryRoomElectricityRecharge/getChargingWxPayUrlForStuDto', params)
}

/* 新电表 更新支付状态
* @params {string} payRecordId 充值记录id
*  */
export const refreshNewMeterPayStatusApi = (payRecordId) => {
  return request.post(`/handle/dormitoryRoomElectricityRecharge/getById/${payRecordId}`)
}

/* 新电表 开启电表
* @params {string} meterId 电表id
*  */
export const turnOffNewElectricityMeterApi = (meterId) => {
  return request.post(`/handle/dormitoryRoomElectricityMeter/closeElectricityMeter/${meterId}`)
}

/* 新电表 关闭电表
* @params {string} meterId 电表id
*  */
export const turnOnNewElectricityMeterApi = (meterId) => {
  return request.post(`/handle/dormitoryRoomElectricityMeter/openElectricityMeter/${meterId}`)
}
